<script>
import {UContextMenu} from 'uloc-vue'
import ListMenu from './list-menu'

export default {
  name: 'ContextMenuReboqueItem',
  props: ['reboque'],
  data () {
    return {
      atualizando: false
    }
  },
  computed: {},
  methods: {
  },
  components: {ListMenu, UContextMenu}
}
</script>

<template>
  <u-context-menu ref="context" class="erp-context-menu">
    <list-menu @abrir="$emit('abrir')" />
  </u-context-menu>
</template>
